import PageOverPortal from 'components/Portal/PageOverPortal'
import React, { useCallback, useEffect, useState } from 'react'
import BondConnectPDPATitle from './BondConnectPDPATitle';
import BondConnectPDPAContent from './BondConnectPDPAContent';
import { DocumentUtil } from 'utils/common-util';
import { Button } from 'antd';
import IntlMessages from 'components/Message/IntlMessages';
import { DisclaimerType } from 'const';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { hideAllMainMenu, showAllMainMenu } from 'redux/reducers/auth';

function BondConnectPDPA({ visible, close, actions }) {
  const dispatch = useDispatch();
  const [enableAcceptBtn, setEnableAcceptBtn] = useState(false);

  useEffect(() => {
    if (visible) {
      dispatch(hideAllMainMenu());
      DocumentUtil.disableScroll();
    } else {
      dispatch(showAllMainMenu());
      DocumentUtil.enableScroll();
    }
    return () => DocumentUtil.enableScroll();
  }, [dispatch, visible]);

  const _onAccept = useCallback(() => {
    close();
    actions?.onAccept && actions.onAccept(DisclaimerType.BondConnectPDPA);
  }, [close, actions]);

  const _onCancel = useCallback(() => {
    close();
    actions?.onCancel && actions.onCancel();
  }, [close, actions]);

  const renderBottom = useCallback(
    (readCompleted) => {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center gap-3 w-100 py-4">
          {readCompleted && (
            <Button className="btn button-ktb-main w-100 mx-3" onClick={_onAccept} disabled={!enableAcceptBtn}>
              <IntlMessages id="global.acknowledge.and.accept" />
            </Button>
          )}
          <Button className="btn button-ktb-line w-100 mx-3" onClick={_onCancel}>
            <IntlMessages id="global.cancel" />
          </Button>
        </div>
      );
    },
    [_onAccept, _onCancel, enableAcceptBtn]
  );

  const onReadCompleted = useCallback(() => {
    setEnableAcceptBtn(true);
  }, []);

  if (!visible) return null;

  return (
    <PageOverPortal className="bond-connect-pdpa-portal" animated={true}>
      <BondConnectPDPAContentStyled className="bond-connect-pdpa">
        <BondConnectPDPATitle onCancel={_onCancel} />
        <BondConnectPDPAContent
          renderBottom={renderBottom}
          onReadCompleted={onReadCompleted}
          adjustPdfViewSize={-adjustPdfViewSize}
        />
      </BondConnectPDPAContentStyled>
    </PageOverPortal>
  )
}

const headerHeight = 72;
const titleBarHeight = 74;
const adjustPdfViewSize = headerHeight + titleBarHeight;

const BondConnectPDPAContentStyled = styled.div`
  height: 100vh;
  position: relative;
  background: white;
`;

export default BondConnectPDPA;